// Mock data for High Quality Studios

export const engineers = [
  {
    id: 1,
    name: "Trap Spade",
    specialty: "Head Engineer & Producer",
    experience: "Lead Professional",
    bio: "Lead engineer with the most experience and highest skill level in the studio. Delivers premium guidance, fastest workflow, and expertly polished mixes. Known for exceptional attention to detail and producing industry-standard results. Musical taste: Trap, Drill, Melodic Rap, R&B, Afrobeats, Jersey Club, Rage, and everything in between—versatile across all genres with deep roots in street sound and contemporary production.",
    rate: "$50/hour",
    premium: true,
    hourlyRate: 50,
    eightHourRate: 340,
    bundleRate: 125,
    fiveHourRate: 225,
    sixHourRate: 250,
    email: "trapspade@hqstu.com",
    instagram: "https://www.instagram.com/trapspade_/"
  },
  {
    id: 2,
    name: "Chapo",
    specialty: "Recording Engineer",
    experience: "Professional",
    bio: "Skilled recording engineer delivering clean, professional results. Specializes in melodic vocal production with efficient session workflow. Musical taste: Melodic Rap, R&B, Pop, Alternative Hip-Hop, Hyperpop, and emotionally driven music—excels at capturing vocal emotion and creating atmospheric soundscapes.",
    rate: "$40/hour",
    hourlyRate: 40,
    eightHourRate: 280,
    bundleRate: 120,
    fiveHourRate: 200,
    sixHourRate: 240,
    email: "menaidelgado@gmail.com",
    instagram: "https://www.instagram.com/mixedbychapo/"
  },
  {
    id: 3,
    name: "Dev",
    specialty: "Recording Engineer & Producer",
    experience: "Professional",
    bio: "Versatile engineer and producer specializing in underground sounds. Works primarily in Ableton with a focus on experimental production techniques. Musical taste: Underground Rap, SoundCloud Rap, Plugg, Rage, Electronic Fusion, Dark Trap, Witch House, and avant-garde hip-hop—pushes boundaries with unconventional textures and left-field production.",
    rate: "$40/hour",
    hourlyRate: 40,
    bundleRate: 100,
    email: "dev@hqstu.com",
    instagram: "https://www.instagram.com/j_ackal/",
    active: false
  },
  {
    id: 4,
    name: "Shotz",
    specialty: "Recording Engineer & Producer",
    experience: "Professional",
    bio: "Dynamic producer and engineer with expertise in hard-hitting drill production. Creates authentic street sound using FL Studio with heavy sampling techniques. Musical taste: Drill, Trap, Hip-Hop, Afrobeats, Sample-Heavy Production, UK Drill, Brooklyn Drill, Amapiano, Grime, and experimental dark sounds—specializes in gritty, bass-heavy beats with aggressive energy and street authenticity.",
    rate: "$40/hour",
    hourlyRate: 40,
    bundleRate: 100,
    fiveHourRate: 180,
    email: "shotz@hqstu.com",
    instagram: "https://www.instagram.com/prodshotz/",
    bookable: false,
    active: false
  },
  {
    id: 5,
    name: "Duse",
    specialty: "Recording Engineer",
    experience: "Professional",
    bio: "Seasoned recording engineer with years behind the board — the kind of ear that knows exactly where a vocal should sit, when a pocket feels off, and how to pull the best performance out of any artist. Duse runs tight, well-paced sessions and delivers clean, polished, radio-ready records. Rappers, singers, and producers all come out of his room sounding sharper.",
    rate: "$40/hour",
    hourlyRate: 40,
    eightHourRate: 280,
    bundleRate: 100,
    fiveHourRate: 180,
    sixHourRate: 220,
    email: "duse@hqstu.com",
    instagram: ""
  },
  {
    id: 6,
    name: "PB Slimeyy",
    specialty: "Engineer-in-Training & Rapper",
    experience: "Rising Talent",
    bio: "Hungry up-and-coming engineer and NYC rapper deep in his training grind. Slimeyy brings a rapper's ear to the booth — he knows what a punchline needs to hit, where the ad-libs breathe, and how a hook should sit in the mix. Every session is a chance to link with new artists, sharpen his engineering craft, and swap ideas with the next generation of NYC talent. Book with him and unlock a discounted feature verse from PB Slimeyy on your track for $150 — site bookings only.",
    rate: "$30/hour",
    hourlyRate: 30,
    eightHourRate: 250,
    bundleRate: 90,
    fiveHourRate: 150,
    sixHourRate: 180,
    email: "trapspade@hqstu.com",
    instagram: "",
    septemberSpecial: true
  },
  {
    id: 7,
    name: "WickTheProducer",
    specialty: "Producer & Engineer",
    experience: "Established Producer",
    bio: "Established producer stepping into the engineering chair — bringing years of production instinct into the recording booth. Wick doesn't just capture your vocal, he shapes the whole record around it. Every session unlocks the option to add custom Wick original beats — $50 each — delivered live in-session, so you walk out with heat you actually own. Available every day, all day.",
    rate: "$30/hour",
    hourlyRate: 30,
    eightHourRate: 250,
    bundleRate: 90,
    fiveHourRate: 150,
    sixHourRate: 180,
    email: "realwickdaprod@gmail.com",
    instagram: "",
    phone: "786-273-5998",
    septemberSpecial: true
  },
  {
    id: 8,
    name: "Walkdown Jelly",
    specialty: "Recording Engineer",
    experience: "Intermediate",
    bio: "Intermediate recording engineer bringing solid technical chops and a fresh energy to every session. Walkdown Jelly has put in the reps — he knows how to set the booth up right, catch takes clean, and keep the vibe moving so artists stay locked in. A great fit for upcoming artists ready to level up their sound without burning the clock.",
    rate: "$40/hour",
    hourlyRate: 40,
    eightHourRate: 280,
    bundleRate: 100,
    fiveHourRate: 180,
    email: "chrisnunu555@gmail.com",
    instagram: "",
    phone: "917-704-0589"
  }
];

export const services = [
  {
    id: 1,
    title: "Recording Services",
    description: "Professional recording sessions with in-house engineers",
    pricing: [
      { option: "Standard Engineer", price: "$40/hour", note: "Rough mix included" },
      { option: "Trap Spade (Premium)", price: "$50/hour", note: "Faster workflow" },
      { option: "3-Hour Bundle - Standard", price: "$100", note: "Save $20" },
      { option: "3-Hour Bundle - Trap Spade", price: "$125", note: "Save $25" }
    ],
    features: ["Recording with engineer", "Rough mix at session end", "Stems provided", "Professional setup"]
  },
  {
    id: 2,
    title: "Mixing & Mastering",
    description: "Industry-standard mixing and mastering services",
    pricing: [
      { option: "Mix & Master (Per Song)", price: "$100", note: "2 free revisions" },
      { option: "Rush Mix & Master", price: "$150", note: "24 hour turnaround" }
    ],
    features: ["Full digital mix", "Industry-standard master", "Vocal cleanup + tuning", "WAV + MP3 delivery"]
  },
  {
    id: 3,
    title: "Beat Services",
    description: "Original beats for your projects",
    pricing: [
      { option: "Lease License", price: "$40", note: "Non-exclusive", info: "lease" },
      { option: "Unlimited License", price: "$80", note: "Unlimited songs", info: "unlimited" },
      { option: "Exclusive Rights", price: "$150+", note: "Full ownership + stems", info: "exclusive" }
    ],
    features: ["MP3/WAV delivery", "Trackouts for exclusives", "Custom options", "Perfect for singles"]
  },
  {
    id: 4,
    title: "Visual Content",
    description: "Professional music videos and visual content",
    pricing: [
      { option: "Mic Videos", price: "$150", note: "Performance video" },
      { option: "Music Video (Standard)", price: "$250+", note: "1-2 locations" },
      { option: "Music Video (Heavy FX)", price: "$350+", note: "Advanced effects" }
    ],
    features: ["1080p or 4K delivery", "Professional lighting", "Color grading", "Performance or storyline"]
  },
  {
    id: 5,
    title: "Live Streaming Add-On",
    description: "Stream your session live to any platform",
    pricing: [
      { option: "Per Session", price: "$50", note: "Add to any service" }
    ],
    features: ["Twitch, YouTube, TikTok, IG Live", "Professional camera setup", "High-quality audio", "Full integration"]
  }
];

export const equipment = [
  { category: "Interface", items: ["Universal Audio Apollo", "Focusrite Scarlett"] },
  { category: "DAW", items: ["Pro Tools", "FL Studio", "Ableton Live", "Logic Pro X"] },
  { category: "Production", items: ["Extensive beats library", "MIDI controllers", "Professional outboard gear"] },
  { category: "Studio Features", items: ["Professional lighting setup", "Comfortable lounge area", "Professional recording booth", "PS5 & Xbox gaming", "Snacks & refreshments", "Smoking-friendly environment", "High-speed internet"] }
];

export const testimonials = [
  {
    id: 1,
    name: "DJ Skillz",
    role: "Hip-Hop Artist",
    text: "Best studio in Brooklyn! The engineers know their craft and the vibe is unmatched. Recorded my entire album here.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1534308143481-c55f00be8bd7?w=100&h=100&fit=crop"
  },
  {
    id: 2,
    name: "Sarah Martinez",
    role: "Singer/Songwriter",
    text: "Amazing atmosphere and professional setup. The LED lighting creates the perfect creative mood. Highly recommend!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop"
  },
  {
    id: 3,
    name: "Mike Thompson",
    role: "Producer",
    text: "Quality equipment, reasonable prices, and the engineers really understand what you're going for. Been coming here for 2 years.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop"
  }
];

// Mock available time slots for booking
export const generateTimeSlots = () => {
  const slots = [];
  // 8am to 4am (next day) - includes early bird hours starting at 8am
  const hours = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 0, 1, 2, 3, 4];
  
  hours.forEach(hour => {
    let displayHour = hour;
    let period = 'AM';
    
    if (hour === 0) {
      displayHour = 12;
      period = 'AM';
    } else if (hour === 12) {
      displayHour = 12;
      period = 'PM';
    } else if (hour > 12) {
      displayHour = hour - 12;
      period = 'PM';
    }
    
    slots.push({
      time: `${displayHour}:00 ${period}`,
      available: true // All slots available by default, disabled by component logic
    });
  });
  
  return slots;
};

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_vidstudio-repair/artifacts/7ya942oz_E1880E57-BB95-4E23-8F15-0148D0720D25.jpeg",
    alt: "Studio with purple LED lighting and professional setup"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_63dac94a-0f2a-4ccd-9e98-d528f614ae89/artifacts/6clph73j_493F5211-773A-4308-B0DA-5C2A4C088AFB.jpeg",
    alt: "Studio main production room with LED lighting"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_63dac94a-0f2a-4ccd-9e98-d528f614ae89/artifacts/da48ybqf_B4D6E212-F07D-4BAA-9303-C7F50CE33381.jpeg",
    alt: "Recording setup with equipment"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_63dac94a-0f2a-4ccd-9e98-d528f614ae89/artifacts/2yirv4n3_E4DAAA85-410A-49B1-AF5C-46D144148217.jpeg",
    alt: "Studio workspace"
  }
];

// Mock booking data storage (will be replaced with backend)
export const mockBookings = [];

export const addMockBooking = (booking) => {
  mockBookings.push({
    ...booking,
    id: Date.now(),
    createdAt: new Date().toISOString()
  });
  return mockBookings[mockBookings.length - 1];
};